import { Constants } from '../constants';
import { KratosTokenKey } from '../types';

export type AccentPresentation = {
    label: string;
    color: string;
    tint: string;
};

const TOKEN_PRESENTATION: Record<KratosTokenKey, AccentPresentation> = {
    break: {
        label: 'Break',
        color: '#3b82f6',
        tint: 'rgba(59, 130, 246, 0.16)',
    },
    opening: {
        label: 'Opening',
        color: '#22c55e',
        tint: 'rgba(34, 197, 94, 0.16)',
    },
    fire: {
        label: 'Fire',
        color: '#f97316',
        tint: 'rgba(249, 115, 22, 0.16)',
    },
    rouse: {
        label: 'Rouse',
        color: '#ef4444',
        tint: 'rgba(239, 68, 68, 0.16)',
    },
    black: {
        label: 'Black',
        color: '#6b7280',
        tint: 'rgba(107, 114, 128, 0.18)',
    },
    hope: {
        label: 'Hope',
        color: '#ec4899',
        tint: 'rgba(236, 72, 153, 0.16)',
    },
    closing: {
        label: 'Closing',
        color: '#f8fafc',
        tint: 'rgba(248, 250, 252, 0.18)',
    },
};

const KRATOS_TOKEN_ORDER: KratosTokenKey[] = ['opening', 'closing', 'break', 'black', 'fire', 'hope', 'rouse'];

const TOKEN_VISIBILITY_TAGS: Partial<Record<KratosTokenKey, string>> = {
    black: Constants.SpoilerTag.CYCLE_II,
    fire: Constants.SpoilerTag.CYCLE_II,
    rouse: Constants.SpoilerTag.CYCLE_II,
    hope: Constants.SpoilerTag.CYCLE_III,
    closing: Constants.SpoilerTag.CYCLE_IV,
};

const ARGONAUT_STAT_PRESENTATION = {
    rage: {
        label: 'Rage',
        color: '#ef4444',
        tint: 'rgba(239, 68, 68, 0.16)',
    },
    fate: {
        label: 'Fate',
        color: '#3b82f6',
        tint: 'rgba(59, 130, 246, 0.16)',
    },
    danger: {
        label: 'Danger',
        color: '#22c55e',
        tint: 'rgba(34, 197, 94, 0.16)',
    },
} as const;

export function getKratosTokenPresentation(tokenKey: KratosTokenKey): AccentPresentation {
    return TOKEN_PRESENTATION[tokenKey];
}

export function getVisibleKratosTokenKeys(visibleTags: string[]): KratosTokenKey[] {
    return KRATOS_TOKEN_ORDER.filter((tokenKey) => {
        const requiredTag = TOKEN_VISIBILITY_TAGS[tokenKey];
        return !requiredTag || visibleTags.includes(requiredTag);
    });
}

export function getKratosTokenColorByLabel(label: string): string {
    const presentation = Object.values(TOKEN_PRESENTATION).find((entry) => entry.label === label);
    return presentation?.color ?? '#d8a52a';
}

export function getArgonautStatPresentation(statKey: keyof typeof ARGONAUT_STAT_PRESENTATION): AccentPresentation {
    return ARGONAUT_STAT_PRESENTATION[statKey];
}
